import { getCookie } from "./utils";
import { LANGUAGE_COOKIE_NAME } from "./constants";

class localhostSettings { }

const win: any = window;

if (window.location.href.includes("localhost")) {
    !!!win["lang"] && (win["lang"] = getCookie(LANGUAGE_COOKIE_NAME) || 'en');
    document.documentElement.lang = win["lang"];
    win["isLoggedIn"] = 'false';

    !!!win['CEM_KEY'] && (win['CEM_KEY'] = import.meta.env.VITE_CEM_K);
    !!!win['bmToken'] && (win['bmToken'] = import.meta.env.VITE_BM_TOKEN);
    !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080');
    !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = "https://apisit.mobily.com.sa/api");
    !!!win["errorPageURL"] && (win["errorPageURL"] = "/wps/portal/web/personal/store/error");
}

export default localhostSettings;